<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <zestawieniaMenu></zestawieniaMenu>
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Zestawienia etatów</h4>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="row col-12">
            <div class="col-md-6 mb-4">
              <h5>Zestawienie liczby etatów</h5>
              <div class="custom-table">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead>
                    <tr>
                      <th>#</th>
                      <th>Płeć</th>
                      <th>Ile etatów</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>1</td>
                      <td>Mężczyźni</td>
                      <td>{{ liczba_plec.m }}</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Kobiety</td>
                      <td>{{ liczba_plec.k }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="d-flex justify-content-center w-100">
                <vue-apexcharts type="donut" height="250" :series="wykresDane1" :options="wykresOpcje1" class="w-100"/>
              </div>
            </div>
            <div class="col-md-6 mb-4">
              <h5>Zestawienie sumy etatów</h5>
              <div class="custom-table">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead>
                    <tr>
                      <th>#</th>
                      <th>Płeć</th>
                      <th>Suma etatów</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>1</td>
                      <td>Mężczyźni</td>
                      <td>{{ suma_etatow.m }}</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Kobiety</td>
                      <td>{{ suma_etatow.k }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="d-flex justify-content-center w-100">
                <vue-apexcharts type="donut" height="250" :series="wykresDane2" :options="wykresOpcje2" class="w-100"/>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import vueApexcharts from "vue3-apexcharts";
import zestawieniaMenu from "@/Pages/Kadry/parts/zestawieniaMenu.vue";

export default {
  components: {AppLayout, vueApexcharts, zestawieniaMenu},
  props: {
    liczba_plec: {
      type: Object,
      required: true
    },
    suma_etatow: {
      type: Object,
      required: true
    },
    suma_rekordow: Number,
  },
  computed: {
    // wykres dla sumy jednostek
    wykresDane1() {
      return [this.liczba_plec.k, this.liczba_plec.m]; // uwaga: kolejność zgodna z labels
    },
    wykresOpcje1() {
      return {
        labels: ["Kobiety", "Mężczyźni"],
        colors: ["#f39c12", "#27ae60"],
        legend: {
          position: "bottom"
        },
        dataLabels: {
          enabled: true
        },
        plotOptions: {
          pie: {
            donut: {
              size: "65%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Razem"
                }
              }
            }
          }
        }
      };
    },
    // wykres dla sumy etatów
    wykresDane2() {
      return [this.suma_etatow.k, this.suma_etatow.m];
    },
    wykresOpcje2() {
      return {
        labels: ["Kobiety", "Mężczyźni"],
        colors: ["#ea68d6", "#339bfc"],
        legend: {
          position: "bottom"
        },
        dataLabels: {
          enabled: true
        },
        plotOptions: {
          pie: {
            donut: {
              size: "65%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Razem"
                }
              }
            }
          }
        }
      };
    },	
	
  },
  methods: {
    addTermin() {
      console.log("Dodaj termin kliknięty");
    },
    formatDate(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp);
      return date.toISOString().split("T")[0];
    }
  }
};
</script>

<style scoped>
</style>
